import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner'

import Layout from '../../components/Layout/Default'

import { Container, Content, TitleContainer, Title, LeaderboardsContainer, Prize, Image } from './styles'

import api from '../../services/api'

import LeaderboardPlatform from '../../components/Leaderboards/Platform'

function Leaderboards(){
  const baseUrl = 'https://my.callofduty.com/api/papi-client/leaderboards/v2/title/ctr/platform'

  const prizeImage = process.env.REACT_APP_PRIZE || 'https://i.imgur.com/NRBvMJu.png?1'
  const nitroValue = process.env.REACT_APP_NITROVALUE || '70'
  const championshipValue = process.env.REACT_APP_CHAMPIONSHIPVALUE || '69'
  const leaderboardValues = {
    nitro: nitroValue,
    championship: championshipValue
  }

  const [ loader, setLoader ] = useState(true)
  const [ leaderboards, setLeaderboards ] = useState({})

  async function fetchTop5(platform, value){
    let response
    response = await api.get(`${baseUrl}/${platform}/time/alltime/type/1/mode/${value}/page/1`)
    response = await api.get(`${baseUrl}/${platform}/time/alltime/type/1/mode/${value}/page/${response.data.data.totalPages}`)

    const lastPos = response.data.data.entries.slice(-1)[0]
    const top5 = lastPos.rank * 0.05
    return top5
  }

  async function fetchLeaderboards(type){
    const requests = [
      fetchTop5('psn', leaderboardValues[type]),
      fetchTop5('switch', leaderboardValues[type]),
      fetchTop5('xbl', leaderboardValues[type])
    ]
    const response = await Promise.all(requests)
    const leaderboards = {
      psn: response[0].toFixed(0),
      switch: response[1].toFixed(0),
      xbl: response[2].toFixed(0),
    }

    return leaderboards
  }

  async function getLeaderboards(){
    const requests = [
      fetchLeaderboards('nitro'),
      fetchLeaderboards('championship'),
    ]
    const response = await Promise.all(requests)
    const leaderboards = {
      nitro: response[0],
      championship: response[1]
    }

    console.log(leaderboards)
    setLeaderboards(leaderboards)
    setLoader(false)
  }

  useEffect(() => {
    getLeaderboards()
  }, [])

  function renderLoader(){
    return(
      <Loader 
        type="Circles"
        color="#FFF"
        height="100"	
        width="100"
      />   
    )
  }

  function renderLeaderboards(){
    return(
      <>
        <TitleContainer>
          <Title>LEADERBOARDS TOP 5%</Title>
        </TitleContainer>
        <LeaderboardsContainer>
          <LeaderboardPlatform platform={ 'Playstation'} nitro={ leaderboards.nitro.psn } championship={ leaderboards.championship.psn }/>
          <LeaderboardPlatform platform={ 'Switch'} nitro={ leaderboards.nitro.switch } championship={ leaderboards.championship.switch }/>
          <LeaderboardPlatform platform={ 'Xbox One'} nitro={ leaderboards.nitro.xbl } championship={ leaderboards.championship.xbl }/>
        </LeaderboardsContainer>
      </>
    )
  }
  
  return (
    <Layout selected="leaderboards">
      <Container>
        <Content>
          { loader ? renderLoader() : renderLeaderboards() }
        </Content>
        <Prize>
          <TitleContainer>
            <Title>FINISH IN THE TOP 5% TO EARN</Title>
          </TitleContainer>
          <Image src={ prizeImage }></Image>
          <TitleContainer>
            <Title>CHAMPION KART AND A SPECIAL DECAL</Title>
          </TitleContainer>
        </Prize>
      </Container>
    </Layout>
  )
}

export default Leaderboards